<div class="flex items-center justify-between">
    <h2 mat-dialog-title class="text-lg font-bold">
        Nota
    </h2>
    <div class="flex items-center mr-4">
        <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close
            style="cursor: pointer;"></mat-icon>
    </div>
</div>
<mat-dialog-content class="modal-content !pt-0">
    <div class="flex flex-wrap gap-x-8  p-2 border border-gray-200 rounded bg-gray-50 text-sm text-black">
        <p class="m-0"><strong>Material:</strong>
            {{ data.detail.material?.externalKeys?.code || data.detail.material?.code }} -
            {{ data.detail.material?.name }}
        </p>
    </div>
    <div class="mt-2">
        <div class="p-4 border border-gray-200 rounded bg-white">
            <p class="whitespace-pre-wrap text-sm text-black m-0"><strong>Comentario: </strong> {{ data.detail.note }}
            </p>
        </div>
        <ng-container *ngIf="!data.detail.note || data.detail.note.trim() === ''">
            <div class="flex justify-center items-center h-32">
                <p class="text-gray-500 m-0">No hay nota disponible</p>
            </div>
        </ng-container>
    </div>
</mat-dialog-content>